import { centsToFormattedDollars } from '@fruitful/fruitils';
import type {
    DeepPartial,
    MoneyMapRuleWithAccountDetails,
} from '@fruitful/types';
import { MoneyMapRuleGoalType } from '@fruitful/types';

export const getWhatThisMeansText = (
    rule: DeepPartial<MoneyMapRuleWithAccountDetails>,
): string => {
    const {
        goalType,
        targetBalanceCents,
        monthlyContributionMaxCents,
        yearlyContributionMaxCents,
    } = rule;
    const formattedTargetBalance =
        targetBalanceCents != null && targetBalanceCents > 0
            ? centsToFormattedDollars(targetBalanceCents, false)
            : null;
    const formattedMonthlyLimit =
        monthlyContributionMaxCents != null && monthlyContributionMaxCents > 0
            ? centsToFormattedDollars(monthlyContributionMaxCents, false)
            : null;
    const formattedYearlyLimit =
        yearlyContributionMaxCents != null && yearlyContributionMaxCents > 0
            ? centsToFormattedDollars(yearlyContributionMaxCents, false)
            : null;

    const untilParts: string[] = [];

    if (goalType === MoneyMapRuleGoalType.BUILD_UP_TARGET_BALANCE) {
        untilParts.push(
            formattedTargetBalance != null
                ? `account balance is ${formattedTargetBalance}`
                : 'target balance is reached',
        );
    } else if (goalType === MoneyMapRuleGoalType.DEBT_PAY_DOWN) {
        untilParts.push(
            formattedTargetBalance != null
                ? `total contribution reaches ${formattedTargetBalance}`
                : 'debt is paid off',
        );
    } else if (formattedMonthlyLimit == null && formattedYearlyLimit == null) {
        return 'Contribute indefinitely';
    }

    if (formattedMonthlyLimit != null) {
        untilParts.push(`${formattedMonthlyLimit} monthly limit is reached`);
    }
    if (formattedYearlyLimit != null) {
        untilParts.push(`${formattedYearlyLimit} annual limit is reached`);
    }

    if (untilParts.length === 0) {
        return 'Contribute indefinitely';
    }

    return `Contribute until ${untilParts.join(' or until ')}`;
};
